import canReactivate from './canReactivate';
import { ProceedAction, TPunishment } from './types';

function determineProceedAction(punishmentData: TPunishment): ProceedAction | null {
  const { punishmentTypeDescription, endDate } = punishmentData;

  switch (punishmentData.verificationCategory) {
    case 'Email':
      return ProceedAction.VerifyEmail;
      break;
    case 'VPC':
      return ProceedAction.VerifyVPC;
      break;
    default:
      if (canReactivate(punishmentTypeDescription, endDate)) {
        return ProceedAction.Reactivate;
      }
      return null;
  }
}

export default determineProceedAction;
